/*
 * @Author: LiuGuangMing
 * @Date: 2018-12-06 17:11:34
 * @Last Modified by: LiuGuangMing
 * @Last Modified time: 2019-01-17 13:46:56
 */
<template>
    <div class="container">
        <div :class="{content: true, empty: listData && listData.length === 0}">
            <div class="panel">
                <ul>
                    <li>
                        <label>状态</label>
                        <button :class="{active:tab==0}" @click="tabSwitch(0)">全部</button>
                        <button :class="{active:tab==1}" @click="tabSwitch(1)">草稿</button>
                        <button :class="{active:tab==2}" @click="tabSwitch(2)">已发布</button>
                    </li>
                    <li>
                        <button class="add" @click="dialogView('addProposal')">新建提案</button>
                    </li>
                </ul>
            </div>
            <div class="line">
                <p></p>
            </div>
            <div :class="{table: true, empty: listData && listData.length === 0}">
                <dl>
                    <li v-if="listData && listData.length > 0">
                        <dt>提案标题</dt>
                        <dt v-if="tabStatus === -1">创建/提交时间</dt>
                        <dt v-if="tabStatus === 0">创建时间</dt>
                        <dt v-if="tabStatus === 1">提交时间</dt>
                        <dt>状态</dt>
                        <dt>操作</dt>
                    </li>
                    <empty :mTop="30" v-if="listData && listData.length === 0" :msg="'暂无提案数据'" />
                    <li v-for="(item,index) in listData" :key="index">
                        <dd class="twoline" @click="dialogView('infoSee',index)">{{item.title}}</dd>
                        <dd>{{item.raw_add_time}}</dd>
                        <dd v-if="item.status!=0">已发布</dd>
                        <dd v-else class="active">草稿</dd>

                        <dd><button v-if="item.status==0" @click="dialogView('edit',index)">编辑</button></dd>
                    </li>
                </dl>
            </div>
            <pages :page_count="page.page_count" :index="page.pageIndex" :total="page.total"></pages>
            <!-- 弹出 -->
            <div class="dialog" v-if="dialog.dialog">
                <!-- 提案新建编辑 -->
                <div :class="{addProposal:!dialog.infoSee,infoSee:dialog.infoSee}" v-if="dialog.addProposal">
                    <div class="top">
                        <h4>{{dialog.dialogTitle}}</h4>
                        <span @click="dialogView"></span>
                    </div>
                    <ul>
                        <li class="info" v-if="dialog.infoSee">
                            <span>{{info.userName}}</span>
                            <span>{{info.dateTime}}</span>
                        </li>
                        <li class="title" v-else>
                            <input :readonly="dialog.infoSee" type="text" placeholder="请输入提案标题" v-model="info.title" maxlength="60" />
                            <span>{{(info.title || '').length}}/60</span>
                        </li>
                        <li>
                            <label>完成工作</label>
                            <p class="detailPart" v-if="dialog.infoSee">{{info.work}}</p>
                            <textarea v-else :readonly="dialog.infoSee" placeholder="请输入完成的工作内容" v-model="info.work"></textarea>
                        </li>
                        <li>
                            <label>计划安排</label>
                            <p class="detailPart" v-if="dialog.infoSee">{{info.plan}}</p>
                            <textarea v-else :readonly="dialog.infoSee" placeholder="请输入计划的安排内容" v-model="info.plan"></textarea>
                        </li>
                        <li>
                            <label>需要协调</label>
                            <p class="detailPart" v-if="dialog.infoSee">{{info.coordination}}</p>
                            <textarea v-else :readonly="dialog.infoSee" placeholder="请输入需要协调的内容" v-model="info.coordination"></textarea>
                        </li>
                        <li v-if="!dialog.infoSee" class="btn button">
                            <button @click="dialogView('save')">保存草稿</button>
                            <button @click="dialogView('post')">提交</button>
                        </li>
                         <!-- <li v-else class="btn button">
                            <button class="exit" @click="dialogView">关闭</button>
                        </li> -->
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {apis} from '@common/config'
import common from '@common/common'
import pages from '@components/pages.vue'
import empty from '@components/empty'

export default{
    components: {
        pages, empty
    },
    data (){

        return{

            listData: null,

            tabStatus: -1,

            tab: 0,

            info: {

                id: '',

                title: '',

                work: '',

                plan: '',

                coordination: '',

                status: 0,

                userName: null,

                dateTime: null,

                len: 0
            },
            page: {

                pageIndex: 1,

                pagesize: 10,

                page_count: 0,

                total: 0
            },
            dialog: {

                dialogTitle: null,

                dialog: false,

                addProposal: true,

                infoSee: false,
            }
        }
    },
    methods: {
        //获取列表
        getList (){
            const id = this.$route.params.id
            let data = {
                idstring: id,

                page: this.page.pageIndex,

                pagesize: this.page.pagesize,

                status: this.tabStatus
            }

            common.myFetch(apis.myProposal, data)

            .then((res)=>{

                this.listData = res.list;

                this.page.page_count = res.page.page_count;

                this.$set(this.page, 'total', res.page.row_count - 0)
            })
        },
        //新建编辑
        dialogView (type,index){
            // if (type === 'save' || type === 'post') {
            //   if (!this.info.title) {
            //     this.$toast('请输入标题')
            //     return
            //   }
            // }

            // this.dialog.dialog = !this.dialog.dialog;

            // this.dialog.addProposal = !this.dialog.addProposal;
            if(type == 'addProposal'){
            // 点击新建按钮
                this.dialog.dialogTitle = "新建提案";
                this.dialog.infoSee = false

                this.info = {

                    id: '',

                    title: '',

                    work: '',

                    plan: '',

                    coordination: ''
                }

                this.dialog.dialog = true
            } else if(type == 'edit' || type == 'infoSee'){
              //点击编辑按钮或标题查看
               let item = this.listData[index]
               this.dialog.infoSee = false

               this.info= {

                    id: item.id,

                    title: item.title,

                    work: item.finished_work,

                    plan: item.plan,

                    coordination: item.coordination,

                    userName: item.user_name,

                    dateTime: item.raw_add_time
               }
               this.info.len = this.info.title.length;

               this.dialog.dialogTitle = "编辑提案";

               if(type == 'infoSee'){

                    this.dialog.dialogTitle = this.info.title;
                    this.dialog.infoSee = true;

                    this.info.title = item.title || '暂无'
                    this.info.work = item.finished_work || '暂无'
                    this.info.plan = item.plan || '暂无'
                    this.info.coordination = item.coordination || '暂无'
                }

                this.dialog.dialog = true
            } else if(type == 'save' || type == 'post'){
              //点击弹窗中保存或提交

                let data = {

                    id: this.info.id,

                    title: this.info.title,

                    finished_work: this.info.work,

                    plan: this.info.plan,

                    coordination: this.info.coordination,

                    status: 0
                }

                if(type == 'post'){

                    data.status = 1;
                }

                this.queryProposal(apis.creatProposal, data)
                .then((r) => {
                  if (r) {
                    this.dialog.dialog = false

                    this.getList()
                  }
                })
            } else {
                // 其他类型（关闭按钮）
                // this.dialog.infoSee = false;
                this.dialog.dialog = false
            }
        },
        //创建提交
        queryProposal (url,data){
            return common.myFetch(url, data)
            .then((res)=>{
              return res
            })
        },
        //分类切换
        tabSwitch (index){
            if (this.tab === index) return

            this.tabStatus = index-1;

            this.page.pageIndex = 1;

            this.getList();

            this.tab = index;
        },
        //输入统计
        keyup (){

            // let len = this.info.title.length;
            //
            // this.info.len = len;

        }
    },
    mounted() {

        this.getList();
    }
}
</script>

<style src="@assets/css/proposal/proposal.less" lang="less" scoped></style>
